import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { ReturnSummaryDto } from '@interfaces/partner-income-tax/responses/partner-income-tax.response';
import { VaultDatePipe } from '@src/app/shared/pipes/vault-date.pipe';
import {
  describeReturnKind,
  describeReturnStatus,
} from '@features/dashboard/performance/pages/dfp/components/partner-income-tax/utils/partner-income-tax-format.util';

/**
 * Linha do tempo das declarações (protótipo 01), dentro do herói do sócio. Um ponto por declaração, do mais antigo
 * ao mais novo: ano, IRPF, ano-calendário e o tipo com a data de entrega (ou o status, se não foi lida). A
 * selecionada fica verde; a próxima, tracejada com o prazo; a que falhou, vermelha. Clicar numa declaração lida troca
 * o ano em análise (`?calendarYear=` no GET do sócio), como o antigo "Histórico de declarações".
 */
@Component({
  selector: 'app-pit-return-timeline',
  standalone: true,
  imports: [VaultDatePipe],
  templateUrl: './return-timeline.component.html',
  styleUrl: './return-timeline.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReturnTimelineComponent {
  readonly returns = input.required<ReturnSummaryDto[]>();
  readonly selectedCalendarYear = input<number | null>(null);
  readonly selectYear = output<number>();

  protected readonly kindLabel = describeReturnKind;
  protected readonly statusLabel = describeReturnStatus;

  /** Do mais antigo para o mais novo (o DTO vem do mais recente para o mais antigo). */
  protected readonly items = computed(() =>
    [...this.returns()].sort((a, b) => a.exerciseYear - b.exerciseYear)
  );

  protected isSelected(item: ReturnSummaryDto): boolean {
    return item.calendarYear === this.selectedCalendarYear();
  }

  /** Só declaração lida pode virar o ano em análise. */
  protected canSelect(item: ReturnSummaryDto): boolean {
    return !!item.returnId && (item.status === 'extracted' || item.status === 'needs-review');
  }
}
